// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__34E2m","title":"FrontImage_title__3954c"};